import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100"
}
const _hoisted_2 = {
  class: "text pad40",
  style: {"color":"#696969"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = { class: "mt20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: `appo_openScheduleType`,
  class: "fs12 fw600 ml5"
}, "公開する", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { class: "mt20" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: `appo_canLinkToScheduleView`,
  class: "fs12 fw600 ml5"
}, "確定一覧ページから日程の再提案をできるようにする", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "fl mt20"
}
const _hoisted_12 = { class: "fs12 w100 fw600" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "fl" }
const _hoisted_15 = { class: "fl mt20 ml10" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = { class: "ml40 mt20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.astagId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _createTextVNode(" 公開すると、"),
            (_ctx.vrm.openMember)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.vrm.openMember.name) + "様が", 1))
              : _createCommentVNode("", true),
            _createTextVNode("指定のURLから確定一覧をいつでも確認できるようになります。いつでも公開を停止することができます。 ")
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CheckboxTag, {
              value: `openScheduleType`,
              name: `openScheduleType`,
              checked: _ctx.openScheduleType == `all`,
              onClickCheckbox: _ctx.clickOpenScheduleType,
              prefix: `appo`,
              class: "ml1",
              style: {"margin-right":"5px"}
            }, null, 8, ["checked", "onClickCheckbox"]),
            _hoisted_6
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CheckboxTag, {
              value: `canLinkToScheduleView`,
              name: `canLinkToScheduleView`,
              checked: _ctx.canLinkToScheduleView || false,
              onClickCheckbox: _ctx.clickCanLinkToScheduleView,
              prefix: `appo`,
              class: "ml1",
              style: {"margin-right":"5px"}
            }, null, 8, ["checked", "onClickCheckbox"]),
            _hoisted_9
          ]),
          _hoisted_10,
          (_ctx.openUuid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, [
                  _createVNode(_component_CopyButton, {
                    linkUrl: _ctx.uuidUrl(),
                    gtagCategory: `AstagUUIDを取得`,
                    class: "fr"
                  }, null, 8, ["linkUrl"])
                ]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_TextfieldTag, {
                    style: {"height":"50px","min-width":"420px","max-width":"100%","margin-top":"10px"},
                    class: _normalizeClass(`fl fs14 roundForm w100 copyAstagUUID`),
                    value: _ctx.uuidUrl(),
                    onClickTextfield: _ctx.clickTextfield
                  }, null, 8, ["value", "onClickTextfield"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/refresh.png`),
                    width: "20",
                    height: "20",
                    class: "pointer",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickRefresh && _ctx.clickRefresh(...args)))
                  }, null, 8, _hoisted_16), [
                    [_directive_tooltip, `URLを更新（元のURLは使えなくなります）`]
                  ])
                ]),
                _hoisted_17
              ]))
            : _createCommentVNode("", true),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              type: "submit",
              class: "pointer centered circle_button skyblueBg fs14 rad8 mr20",
              style: {"height":"50px"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save(false)))
            }, " 変更を保存 ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}